// THE one upgrade-gate pattern (spec §7 connective repairs): what's missing +
// which plan has it + a REAL "upgrade →" link to billing. Display name comes
// ONLY from PLANS[planKey].label — the pro-sold-as-"Starter" trap (locked #20)
// is enforced here, so no gate can ever leak an internal key.
import type { ReactNode } from 'react';
import { PLANS } from '@pageboss/shared';

export type UpgradePlanKey = 'pro' | 'business' | 'growth';

export interface UpgradeGateProps {
  /** Plain sentence about what's missing, lowercase brand voice. */
  missing: string;
  /** INTERNAL plan key that unlocks it. Rendered via its display label only. */
  planKey: UpgradePlanKey;
  billingHref?: string;
  /** Host override for client-side routing. */
  renderLink?: (props: { href: string; children: ReactNode }) => ReactNode;
}

export function UpgradeGate({
  missing,
  planKey,
  billingHref = '/app/billing',
  renderLink,
}: UpgradeGateProps) {
  const planName = PLANS[planKey].label;
  const label = `upgrade to ${planName} →`;
  return (
    <div data-gate-plan={planKey} role="note" className="rounded-lg border border-border bg-surface-sunken px-5 py-4">
      <p className="text-sm text-text-primary">{missing}</p>
      <p className="mt-1 text-sm text-text-secondary">Included in the {planName} plan.</p>
      <div className="mt-3">
        {renderLink ? (
          renderLink({ href: billingHref, children: label })
        ) : (
          <a href={billingHref} className="text-sm font-semibold text-brand-700 hover:text-brand-800">
            {label}
          </a>
        )}
      </div>
    </div>
  );
}
